<template>
  <div class="TeacherResource">
    <div class="resource-detail-block">
      <!-- <div class="top-line">
        <div class="small-button" @click="toBack()">返回</div>
        <span class="title">我的主页</span>
      </div> -->

      <!-- 详情 -->
      <resource-detail
        :show="detailShow"
        @onReturn="detailShow = false"
        :detailData="detailData"
        detailType="3"
        :examineStatus="menuStatus"
        @toEdit="toEdit"
      ></resource-detail>
    </div>
  </div>
</template>

<script>
import { getFileType } from '@/utils/utils.js'
import { findResource, deleteResource, resDetail } from '@/api/api.js'
import ResourceDetail from '../../components/resourceDetail.vue'

export default {
  components: { ResourceDetail },
  name: 'TeacherResource',
  data: () => ({
    menuStatus: 0, // 审核状态 1待审核 0已通过 -1驳回

    detailShow: false,
    detailData: {},
  }),
  async mounted() {
    // this.refresh()
    this.menuStatus = this.$route.query.status
    resDetail(this.$route.query.id).then((res) => {
      if (res.data.code == 0) {
        console.log('res', res)
        let data = { ...res.data.data }
        data.last_verify = res.data.data.verify[res.data.data.verify.length - 1]
        this.detailData = data
        this.detailShow = true
      }
    })
  },
  methods: {
    toBack() {
      this.$router.back()
    },
    getFileType,
    getDisplayCount(num) {
      if (num > 9999) {
        return Math.floor(num / 1000) / 10 + 'w'
      } else {
        return num
      }
    },
    selectMenu(status) {
      this.menuStatus = status
      this.pageNum = 1
      this.refresh()
    },
    pageChange(e) {
      console.log('paginationChage', e)
      this.pageNum = e
      this.refresh()
    },
    refresh() {
      let data = {
        page: this.pageNum,
        status: this.menuStatus,
        my: 1,
      }
      findResource(data).then((res) => {
        console.log('TeacherResource-findResource', res)
        this.data = res.data.data.list
        this.total = res.data.data.total
      })
    },

    toPreview(item) {
      console.log('toPreview', item)
      this.detailShow = true
      setTimeout(() => {
        this.detailData = item
      }, 10)
    },
    toDelete(item) {
      this.$confirm('确认删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        console.log('toDelete', item)
        deleteResource({ id: item.id }).then((res) => {
          console.log('deleteResource', res)
          if (this.data.length == 1 && this.pageNum > 1) {
            this.pageNum = this.pageNum - 1
          }
          this.refresh()
        })
      })
    },

    toEdit() {
      console.log('toEdit')
      this.$router.push({ path: '/upload', query: { edit: this.detailData } })
      this.detailShow = false
    },
  },
}
</script>

<style lang="less" scoped>
.TeacherResource {
  width: 100%;
  height: 100%;
  padding: 20px;
  box-sizing: border-box;
  .munu {
    border: 1px solid #dcdfe6;
    &:hover {
      // color: #27b2fe;
      // background-color: #fff;
      // border: 1px solid #dcdfe6;
      // #ECF5FF
    }
  }
  .munu-select {
    color: #fff;
    background: #27b2fe;
  }
  .data {
    display: flex;
    justify-content: center;
    align-items: center;
    .data-item {
      margin-right: 29px;
      font-size: 14px;
      color: #4c4c4c;
      &:last-child {
        margin-right: 0;
      }
      .data-icon {
        margin-right: 4px;
      }
    }
  }

  .preview {
    width: 56px;
    height: 24px;
    margin: 0 6px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #00aeff;
    line-height: 22px;
    text-align: center;
    border-radius: 12px;
    border: 1px solid #00aeff;
    cursor: pointer;
  }
  .delete {
    width: 56px;
    height: 24px;
    margin: 0 6px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #808080;
    line-height: 22px;
    text-align: center;
    border-radius: 12px;
    border: 1px solid #808080;
    cursor: pointer;
  }
  .pagination {
    float: right;
  }

  .resource-detail-block {
    position: fixed;
    top: 100px;
    left: 0;
    width: 100vw;
    padding: 0 140px;
    height: calc(100vh - 100px);
    background: #f2f5f8;
    box-sizing: border-box;
    z-index: 9;
    .top-line {
      display: flex;
      height: 81px;
      align-items: center;
    }
    .small-button {
      width: 56px;
      height: 24px;
      border-radius: 12px;
      border: 1px solid #00aeff;
      text-align: center;
      line-height: 24px;
      font-size: 14px;
      color: #00aeff;
      user-select: none;
      cursor: pointer;
    }
    .title {
      font-size: 18px;
      color: #4d4d4d;
      margin-left: 20px;
    }
  }
}
</style>
